import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaCookieBite } from 'react-icons/fa';

const CookiePolicy = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50">
            {/* Header */}
            <header className="bg-white shadow-sm border-b border-gray-200">
                <div className="container mx-auto px-4 py-4">
                    <Link to="/" className="inline-flex items-center text-pink-600 hover:text-pink-700 font-semibold transition-colors">
                        <FaArrowLeft className="mr-2" />
                        Back to Home
                    </Link>
                </div>
            </header>

            {/* Content */}
            <div className="container mx-auto px-4 py-12 max-w-4xl">
                <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
                    {/* Title */}
                    <div className="flex items-center mb-8">
                        <FaCookieBite className="text-4xl text-pink-600 mr-4" />
                        <div>
                            <h1 className="text-4xl font-black text-gray-900">Cookie Policy</h1>
                            <p className="text-gray-600 mt-1">Last updated: December 16, 2025</p>
                        </div>
                    </div>

                    {/* Content Sections */}
                    <div className="space-y-8 text-gray-700">
                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. What Are Cookies</h2>
                            <p className="leading-relaxed">
                                Cookies are small text files that are placed on your device (computer, smartphone, or tablet) when you visit a website. They are widely used to make websites work more efficiently and provide a better user experience by remembering your preferences and login information.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. How We Use Cookies</h2>
                            <p className="leading-relaxed mb-3">
                                SoulMate uses cookies for the following purposes:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Essential cookies: To enable core functionality such as page navigation and access to secure areas of the website</li>
                                <li>Authentication cookies: To remember that you are logged in and keep your session secure</li>
                                <li>Preference cookies: To remember your settings (language, location, etc.)</li>
                                <li>Analytics cookies: To understand how users interact with our platform and improve performance</li>
                                <li>Marketing cookies: To show relevant features and offers based on your interests</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Types of Cookies We Use</h2>
                            <p className="leading-relaxed mb-3">
                                We use both session and persistent cookies:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li><strong>First-party cookies:</strong> Set directly by SoulMate</li>
                                <li><strong>Third-party cookies:</strong> Set by trusted partners (e.g., analytics providers like Google Analytics)</li>
                                <li><strong>Session cookies:</strong> Temporary and deleted when you close your browser</li>
                                <li><strong>Persistent cookies:</strong> Remain on your device for a set period or until you delete them</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Managing Cookies</h2>
                            <p className="leading-relaxed mb-3">
                                You can control and manage cookies in several ways:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Through your browser settings: Most browsers allow you to refuse or delete cookies</li>
                                <li>Via our cookie consent banner: You can accept or reject non-essential cookies when you first visit our site</li>
                                <li>Third-party opt-out tools: Visit sites like <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer" className="text-pink-600 underline">www.aboutads.info</a> or <a href="https://www.youronlinechoices.eu/" target="_blank" rel="noopener noreferrer" className="text-pink-600 underline">www.youronlinechoices.eu</a></li>
                            </ul>
                            <p className="leading-relaxed mt-4">
                                Note that blocking essential cookies may affect the functionality of the website.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Third-Party Cookies</h2>
                            <p className="leading-relaxed">
                                We work with trusted third-party services (such as Google Analytics, payment processors, and advertising partners) that may set cookies on your device. These cookies help us analyze usage, improve security, and deliver personalized experiences. These partners are required to handle your data in accordance with applicable privacy laws.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Updates to This Policy</h2>
                            <p className="leading-relaxed">
                                We may update this Cookie Policy from time to time to reflect changes in technology or legal requirements. We will notify you of material changes by posting the updated policy on this page and updating the "Last updated" date.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Contact Us</h2>
                            <p className="leading-relaxed">
                                If you have any questions about our use of cookies or this Cookie Policy, please contact us at:
                            </p>
                            <div className="mt-4 p-4 bg-pink-50 rounded-lg">
                                <p className="font-semibold">Email: support@soulmate.com</p>
                                <p className="font-semibold">Phone: +91 1800-123-4567</p>
                                <p className="font-semibold">Address: 123 Matrimony Street, Chennai, Tamil Nadu, India</p>
                            </div>
                        </section>
                    </div>

                    {/* Footer */}
                    <div className="mt-12 pt-8 border-t border-gray-200 text-center">
                        <p className="text-gray-600">
                            Thank you for trusting SoulMate. We are committed to protecting your privacy.
                        </p>
                        <Link to="/" className="inline-block mt-4 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-500 text-white font-semibold rounded-lg hover:shadow-lg transition-all">
                            Back to Home
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookiePolicy;